export const ROLE_OPTIONS = [
  { label: "Doctor", value: "DOCTOR" },
  { label: "Staff", value: "STAFF" },
];

export function formatDateTime(value) {
  if (!value) return "-";
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);
    return d.toLocaleString();
  } catch {
    return String(value);
  }
}

export function normalizeRole(role) {
  if (!role) return "";
  return String(role).toUpperCase();
}

export function roleLabel(role) {
  const r = normalizeRole(role);
  if (!r) return "—";
  if (r === "DOCTOR") return "Doctor";
  if (r === "STAFF") return "Staff";
  return r;
}

export function rolePill(role) {
  const r = normalizeRole(role);
  if (r === "DOCTOR") return "bg-sky-50 text-sky-700 ring-sky-200";
  if (r === "STAFF") return "bg-emerald-50 text-emerald-700 ring-emerald-200";
  return "bg-slate-100 text-slate-700 ring-slate-200";
}

export const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || "").trim());

export const isValidPassword = (password) =>
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]{8,}$/.test(
    String(password || "")
  );

export function extractUsers(res) {
  return Array.isArray(res?.data)
    ? res.data
    : Array.isArray(res)
    ? res
    : Array.isArray(res?.results)
    ? res.results
    : [];
}
